import { render, staticRenderFns } from "./PinturaSidebarHeader.vue?vue&type=template&id=35a0c7f2"
import script from "./PinturaSidebarHeader.vue?vue&type=script&lang=js"
export * from "./PinturaSidebarHeader.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./PinturaSidebarHeader.vue?vue&type=style&index=0&id=35a0c7f2&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports